var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.136,
    height: 62.294,
    viewBox: "0 0 60.136 62.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7247",
    "data-name": "Rectangle 7247",
    width: 60.136,
    height: 62.294,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68431",
    "data-name": "Group 68431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68430",
    "data-name": "Group 68430",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44578",
    "data-name": "Path 44578",
    d: "M42.4,1.178a5.157,5.157,0,0,0-4.445,2.6.8.8,0,0,1-1.316-.01,5.1,5.1,0,0,0-9.529,2.52c.006,5.7,5.035,10.2,9.973,12.536a.547.547,0,0,0,.468,0c4.983-2.365,9.954-6.881,9.948-12.556a5.1,5.1,0,0,0-5.1-5.093",
    transform: "translate(-7.275 -0.316)",
    fill: "#f14950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44579",
    "data-name": "Path 44579",
    d: "M29.543,6.3a5.105,5.105,0,0,1,3.875-4.953A5.1,5.1,0,0,0,27.109,6.3c.006,5.7,5.035,10.2,9.973,12.536a.547.547,0,0,0,.468,0c.228-.108.563-.274.974-.5-4.6-2.442-8.976-6.717-8.981-12.038",
    transform: "translate(-7.274 -0.32)",
    fill: "#e01f27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44580",
    "data-name": "Path 44580",
    d: "M47.7,43.143a1.449,1.449,0,0,0,1.276.83H63.837V67.63a1.869,1.869,0,0,1-1.755,1.965H40.957V30.772Z",
    transform: "translate(-10.99 -8.257)",
    fill: "#c59782"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44581",
    "data-name": "Path 44581",
    d: "M40.957,30.772V69.6h2.355V35.087Z",
    transform: "translate(-10.99 -8.257)",
    fill: "#ac7b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44582",
    "data-name": "Path 44582",
    d: "M26,43.143a1.449,1.449,0,0,1-1.276.83H9.854V67.63a1.87,1.87,0,0,0,1.755,1.965H32.731V30.772Z",
    transform: "translate(-2.643 -8.257)",
    fill: "#c59782"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44583",
    "data-name": "Path 44583",
    d: "M12.2,72.477V48.821H9.849V72.477A1.869,1.869,0,0,0,11.6,74.442H13.96A1.869,1.869,0,0,1,12.2,72.477",
    transform: "translate(-2.642 -13.1)",
    fill: "#ac7b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44584",
    "data-name": "Path 44584",
    d: "M69.358,44.372H48.741a1.449,1.449,0,0,1-1.276-.83L40.957,30.772H62.68A1.96,1.96,0,0,1,64.406,31.9l5.657,11.111a.915.915,0,0,1-.7,1.362",
    transform: "translate(-10.99 -8.257)",
    fill: "#c59782"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44585",
    "data-name": "Path 44585",
    d: "M50.119,43.539l-6.5-12.768H40.956l6.5,12.768a1.449,1.449,0,0,0,1.276.83h2.663a1.449,1.449,0,0,1-1.275-.83",
    transform: "translate(-10.99 -8.257)",
    fill: "#ac7b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44586",
    "data-name": "Path 44586",
    d: "M2.005,44.372H22.628a1.449,1.449,0,0,0,1.276-.83l6.5-12.768H8.68A1.962,1.962,0,0,0,6.955,31.9L1.3,43.006a.916.916,0,0,0,.71,1.366",
    transform: "translate(-0.315 -8.257)",
    fill: "#c59782"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44587",
    "data-name": "Path 44587",
    d: "M3.651,43,9.309,31.893a1.959,1.959,0,0,1,1.725-1.127H8.679a1.961,1.961,0,0,0-1.726,1.127L1.3,43A.916.916,0,0,0,2,44.367H4.359A.916.916,0,0,1,3.651,43",
    transform: "translate(-0.316 -8.255)",
    fill: "#ac7b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44588",
    "data-name": "Path 44588",
    d: "M59.929,42.31,54.284,31.2a2.868,2.868,0,0,0-2.536-1.621H8.388A2.868,2.868,0,0,0,5.852,31.2L.206,42.31A1.918,1.918,0,0,0,.279,44.17,1.7,1.7,0,0,0,1.726,45h4.6V67.352A2.78,2.78,0,0,0,8.986,70.23H51.148a2.78,2.78,0,0,0,2.663-2.878v-9.6a.913.913,0,0,0-1.826,0v9.6a.976.976,0,0,1-.838,1.051H30.98V34.3l4.76,9.369A2.356,2.356,0,0,0,37.828,45H51.986v8.5a.913.913,0,1,0,1.826,0V45h4.6a1.7,1.7,0,0,0,1.447-.83,1.918,1.918,0,0,0,.072-1.864m-58.095.828L7.481,32.025a1.054,1.054,0,0,1,.908-.623H28.58L22.767,42.844a.545.545,0,0,1-.459.331H1.826a.081.081,0,0,1,.009-.039ZM8.149,67.352V45H22.308A2.355,2.355,0,0,0,24.4,43.668l4.76-9.37V68.4H8.988a.977.977,0,0,1-.839-1.048m29.68-24.183a.545.545,0,0,1-.459-.331L31.556,31.4H51.748a1.056,1.056,0,0,1,.909.623L58.3,43.136a.094.094,0,0,1,.01.037Z",
    transform: "translate(0 -7.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44589",
    "data-name": "Path 44589",
    d: "M34.427,18.323a.912.912,0,0,0,.927-1.572c-2.288-1.35-7.61-5.1-7.617-10.74a4.183,4.183,0,0,1,4.741-4.149A4.406,4.406,0,0,1,35.7,4.124,1.7,1.7,0,0,0,38.358,4.1a4.356,4.356,0,0,1,3.756-2.287A4.191,4.191,0,0,1,46.3,5.992c.005,5.372-4.773,9.044-7.622,10.753a.913.913,0,1,0,.94,1.565c5.49-3.3,8.512-7.674,8.508-12.322A6.01,6.01,0,0,0,37.021,2.826,6.01,6.01,0,0,0,25.913,6.014c.005,4.635,3.108,9.122,8.514,12.31",
    transform: "translate(-6.953 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaIcon);
export default __webpack_public_path__ + "static/media/sa_icon.5a5daf53655b3fc7af66a79dc0304a10.svg";
export { ForwardRef as ReactComponent };